(() => {
	if (window.Difrax?.sectionLifecycle) return;
	let e = window.Difrax || {},
		t = new Map(),
		n = (e, t) => {
			let n = [];
			return (
				e.matches?.(t) && n.push(e),
				e.querySelectorAll?.(t).forEach((e) => {
					n.includes(e) || n.push(e);
				}),
				n
			);
		},
		r = (e, t = document, r = {}) => {
			n(t, e.selector).forEach((t) => {
				e.initialized.has(t) || (e.initialized.add(t), e.init(t, r));
			});
		},
		i = (e = document, n = {}) => {
			t.forEach((t) => r(t, e, n));
		};
	document.addEventListener(`DOMContentLoaded`, () =>
		i(document, { reason: `dom-ready` }),
	),
		window.addEventListener(`load`, () =>
			i(document, { reason: `window-load` }),
		),
		window.addEventListener(`resize`, () => {
			t.forEach((e) => {
				typeof e.update == `function` &&
					n(document, e.selector).forEach((t) => {
						e.update(t, { reason: `resize` });
					});
			});
		}),
		document.addEventListener(`shopify:section:load`, (e) => {
			i(e.target, { reason: `shopify:section:load`, event: e });
		}),
		(e.sectionLifecycle = {
			register: ({ name: e, selector: n, init: i, update: a }) => {
				if (!e || !n || typeof i != `function`)
					throw Error(
						`sectionLifecycle.register requires name, selector, and init`,
					);
				if (t.has(e)) return t.get(e);
				let o = {
					name: e,
					selector: n,
					init: i,
					update: a,
					initialized: new WeakSet(),
				};
				return (
					t.set(e, o),
					document.readyState !== `loading` &&
						r(o, document, { reason: `register` }),
					o
				);
			},
			runAll: i,
		}),
		(window.Difrax = e);
})();
